import type { ISearchGroupViewProps } from './ISearchGroupViewProps';
import { SearchHitRow } from './SearchHitRow';

/** Скільки збігів групи показувати (прототип v4: перші 20; кількість у шапці — усі збіги групи). */
const SHOWN = 20;

/** Група збігів модуля (прототип v4 G:L2610): назва 11px великими літерами й кількість IBM Plex Mono, картка рядків з радіусом 10. */
export function SearchGroupView({ group, name }: ISearchGroupViewProps) {
  return (
    <section className="sr-group" aria-label={name}>
      <div className="sr-group__head"><span className="sr-group__name">{name}</span><span className="sr-group__count">{group.count}</span></div>
      <div className="sr-list">{group.hits.slice(0, SHOWN).map((h) => <SearchHitRow key={h.recordId} hit={h} />)}</div>
    </section>
  );
}
